var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bt_menu",
    transform: "translate(-10.467 -15.467)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2109",
    "data-name": "Rectangle 2109",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(10.467 15.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2114",
    "data-name": "Rectangle 2114",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(10.467 22.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2117",
    "data-name": "Rectangle 2117",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(10.467 29.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2110",
    "data-name": "Rectangle 2110",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(17.467 15.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2113",
    "data-name": "Rectangle 2113",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(17.467 22.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2116",
    "data-name": "Rectangle 2116",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(17.467 29.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2111",
    "data-name": "Rectangle 2111",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(24.467 15.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2112",
    "data-name": "Rectangle 2112",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(24.467 22.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2115",
    "data-name": "Rectangle 2115",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(24.467 29.467)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenu);
export default __webpack_public_path__ + "static/media/ic_menu.9b14964e83192e99530069988aa48919.svg";
export { ForwardRef as ReactComponent };